/**
 * Release Notes Content
 *
 * Strings for each section of the "What's New" modal in Layout.tsx.
 * UI chrome follows the CRC Evans (CRCE) design system — see docs/CRCE-AI-Design-System.md.
 * Update the arrays below to modify content without changing the component code.
 */

export const NEW_FEATURES: string[] = [
  'Added support for pass merge and unmerge functionality',
  'Added support for ARC strike document and TQ document upload',
  'Added support for reducer joint assembly production functionality',
  'Added support for NDT and coating document delete functionality',
  'Added material report generation for base pipe, forge, gas, wire, coating, and NDE',
  'Added inspection release note report generation',
  'Added production report generation',
  'Added QC inspection personnel report generation',
  'Added equipment welding, NDE, and QC report generation',
  'Added overall project report generation',
];

export const ENHANCEMENTS: string[] = [
  'Enhanced report table headers aligned with the CRCE design system',
  'Improved approval and signature workflow for better usability',
];

export const BUG_FIXES: string[] = [
  'Fixed issues with report generation',
  'Applied various bug fixes and performance improvements',
];
